var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnbagging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1772352684470,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 41544,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753.365333 632.661333l-60.330666-60.330666L753.365333 512A170.666667 170.666667 0 0 0 512 270.634667l-60.330667 60.330666-60.330666-60.330666 60.330666-60.330667a256 256 0 0 1 362.026667 362.026667z m-120.661333 120.704l-60.330667 60.330667a256 256 0 0 1-362.026666-362.026667l60.288-60.330666 60.330666 60.330666L270.634667 512A170.666667 170.666667 0 0 0 512 753.365333l60.330667-60.330666z m0-422.4l60.330667 60.330667-301.696 301.738667-60.373334-60.373334zM246.4 97.834667l82.432-22.101334 44.202667 164.864-82.432 22.101334z m404.565333 685.568l82.432-22.101334 44.16 164.864-82.432 22.101334zM97.834667 246.4l164.864 44.202667-22.101334 82.389333-164.864-44.16z m685.568 404.565333l164.864 44.16-22.101334 82.432-164.821333-44.117333z",
    fill: "#ffffff",
    "p-id": 41545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbagging);
export default __webpack_public_path__ + "static/media/unbagging.8b660f7a4a92d617247e964774345f2a.svg";
export { ForwardRef as ReactComponent };